stimulusApp.register(
  "reviews-form",
  class extends Stimulus.Controller {
    static targets = ["form", "formItem", "reviewsFrame"]
    static values = {
      url: String,
    }

    #loader = document.createElement("div")

    connect() {
      this.#loader.classList.add(
        "loader",
        "loader_s",
        "loader_static",
        "loader_center",
        "vsec_l",
      )
      this.reviewsFrameTarget.addEventListener(
        "turbo:before-fetch-request",
        (event) => {
          if (event.target == this.reviewsFrameTarget) {
            requestAnimationFrame(() => {
              this.reviewsFrameTarget.insertBefore(
                this.#loader,
                this.reviewsFrameTarget.firstChild,
              )
            })
          }
        },
      )
    }

    change() {
      const params = new URLSearchParams(
        new FormData(this.formTarget),
      ).toString()

      this.reviewsFrameTarget.setAttribute("src", `${this.urlValue}?${params}`)
    }

    reset() {
      this.formItemTargets.forEach((item) => {
        item.options.selectedIndex = 0
      })
      this.reviewsFrameTarget.setAttribute("src", `${this.urlValue}`)
    }
  },
)
